import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrdersRoutingModule } from './orders-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';

import { OrdersComponent } from './orders/orders.component';
import { OrdersDataComponent } from './orders-data/orders-data.component';
import { OrdersDataEmptyComponent } from './orders-data-empty/orders-data-empty.component';
import { OrdersDataTableComponent } from './orders-data-table/orders-data-table.component';
import { OrdersHeaderComponent } from './orders-header/orders-header.component';
import { OrdersSummaryComponent } from './orders-summary/orders-summary.component';
import { OrdersFiltersComponent } from './orders-filters/orders-filters.component';
import { OrdersFilterDialogComponent } from './orders-filter-dialog/orders-filter-dialog.component';
import { OrdersQineticDialogComponent } from './orders-qinetic-dialog/orders-qinetic-dialog.component';
import { OrdersDecidoDialogComponent } from './orders-decido-dialog/orders-decido-dialog.component';
import { OrdersQineticReloadDialogComponent } from './orders-qinetic-reload-dialog/orders-qinetic-reload-dialog.component';
import { OrdersQineticErrorDialogComponent } from './orders-qinetic-error-dialog/orders-qinetic-error-dialog.component';
import { OrdersAmountDialogComponent } from './orders-amount-dialog/orders-amount-dialog.component';
import { OrdersDeleteDialogComponent } from './orders-delete-dialog/orders-delete-dialog.component';
import { OrdersRequestsDialogComponent } from './orders-requests-dialog/orders-requests-dialog.component';

@NgModule({
  declarations: [
    OrdersComponent,
    OrdersDataComponent,
    OrdersDataEmptyComponent,
    OrdersDataTableComponent,
    OrdersHeaderComponent,
    OrdersSummaryComponent,
    OrdersFiltersComponent,
    OrdersFilterDialogComponent,
    OrdersQineticDialogComponent,
    OrdersDecidoDialogComponent,
    OrdersQineticReloadDialogComponent,
    OrdersQineticErrorDialogComponent,
    OrdersAmountDialogComponent,
    OrdersDeleteDialogComponent,
    OrdersRequestsDialogComponent,
  ],
  imports: [
    CommonModule,
    OrdersRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatMenuModule,
  ],
})
export class OrdersModule {}
